import { notFound } from 'next/navigation';

import type { IProductOptions } from '@/entities/product/types';
import type { ISlotOption } from '@/entities/slot/types';
import { utilDateFormat } from '@/lib/date';
import { NEXT_PUBLIC_API_URL } from '@/lib/env';
import { utilEnsureMinDelay, utilFetch } from '@/lib/utils';

interface IParams extends IProductOptions {
  date?: Date | null;
}
const apiGetSlotBoxList = async ({ idx, lng, date }: IParams): Promise<ISlotOption[]> => {
  const startTime = Date.now();

  const response = await utilFetch(lng)(
    `${NEXT_PUBLIC_API_URL}/api/slot/boxes/${idx}${date ? `?date=${utilDateFormat(date, 'YYYY-MM-DD')}` : ''}`,
    {
      method: 'GET',
    },
  );
  const result = await response.json();

  // error handling
  if (!result.ok) {
    notFound();
  }

  const data = filterSlotBoxList(result.data);

  // 최소 0.5초 보장
  await utilEnsureMinDelay(startTime, 400);

  return data;
};

export default apiGetSlotBoxList;

const filterSlotBoxList = (response: any): ISlotOption[] => {
  const boxList = response.map((slotOption: any) => ({
    idx: slotOption.idx,
    title: slotOption.title,
    price: slotOption.price,
    type: slotOption.type,
    maxCount: slotOption.maxCount,
    availableCount: slotOption.availableCount,
    isActive: slotOption.isActive,
  }));

  return boxList;
};
